import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import updateQueryString from 'utils/routes/updateQueryString';
import getCurrentCategory from '../selector/getCurrentCategory';
import setCategoryPageNrOperation from './setCategoryPageNrOperation';
import setParamsFromQueryStringOperation from './setParamsFromQueryStringOperation';

const preserveCategoryFiltersOperation =
  (queryStringWithPreservedFilters: string) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentCategory = getCurrentCategory(store);
    const preserveFilters = currentCategory?.displayPreferences.saveSelectorsBetweenCategories;
    if (preserveFilters) {
      dispatch(setCategoryPageNrOperation(1));
      updateQueryString(queryStringWithPreservedFilters);
      return;
    }
    // reset filters and sorting order
    dispatch(setParamsFromQueryStringOperation('', false));
  };

export default preserveCategoryFiltersOperation;
